import imageSrc from '@/assets/images/review-kiosk-banner.webp';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

type Props = {
    tabIndex?: number;
    lastRef?: (node?: Element | null) => void;
    className?: string;
};

export const ReviewKioskBanner = ({ tabIndex, lastRef, className }: Props) => {
    const { t } = useTranslation();

    return (
        <div
            tabIndex={tabIndex}
            data-interactive
            aria-label={t('shop.modal.tts.carousel.no_review')}
            className={clsx(
                'widescreen:w-[calc(410*var(--vw-unit))] widescreen:h-[calc(552*var(--vh-unit))] widescreen:flex h-[calc(404*var(--vh-unit))] rounded-md focus-border ',
                className
            )}
            ref={lastRef}
        >
            <img src={imageSrc} alt="review-kiosk-banner" className="aspect-[410/552] h-full w-full rounded-md object-cover" />
        </div>
    );
};
